import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PortalHeader from '../components/PortalHeader';
import PageHeader from '../components/PageHeader';
import {
  loadClubReports,
  reportUrl,
  formatReportDate,
} from '../lib/analysisReportsStore';

export default function RaceReports() {
  const { clubId } = useParams();
  const [reports, setReports] = useState(null); // null = loading
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setReports(null);
    setError(null);
    loadClubReports(clubId)
      .then((rows) => { if (!cancelled) setReports(rows); })
      .catch((e) => { if (!cancelled) setError(e.message || String(e)); });
    return () => { cancelled = true; };
  }, [clubId]);

  return (
    <>
      <PortalHeader />
      <div className="page">
        <PageHeader
          backTo={`/clubs/${clubId}`}
          backLabel="Dashboard"
          title="Race Reports"
        />

        <p className="notice">
          Post-race analysis reports generated for this club. Each report opens
          its rendered analysis on the public site.
        </p>

        {error && <div className="error">Couldn’t load reports: {error}</div>}

        {!error && reports === null && <p className="empty-state">Loading reports…</p>}

        {!error && reports !== null && reports.length === 0 && (
          <p className="empty-state">No race reports have been generated for this club yet.</p>
        )}

        {!error && reports !== null && reports.length > 0 && (
          <table className="config-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Vessel</th>
                <th>Course</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {reports.map((r) => {
                const url = reportUrl(r);
                return (
                  <tr key={r.id}>
                    <td>{formatReportDate(r.date)}</td>
                    <td>{r.vesselDisplay || r.vessel || '—'}</td>
                    <td>{r.course ? <code>{r.course}</code> : '—'}</td>
                    <td>
                      {url
                        ? <a href={url} target="_blank" rel="noopener noreferrer">Open report ↗</a>
                        : '—'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
